<template>
  <div class="tip-button" flex="cross:center" ref="tipButton" :style="{backgroundColor:selected&&selectColor?selectColor:''}" :class="{'tip-button-over':status=='over','tip-button-active':selected&&isClose!=true,'close-tip-button-active':selected&&isClose==true,'select_shadow':selected&&isSelectShadow,'tip-glassbutton':type==1}" @click="onClick" @mouseover="onMouseOver" @mouseout="onMouseOut">
    <div style="width:auto;" ref="button" flex="main:center cross:center">
      <div ref="icon" :style="{width:radius,height:radius}" flex="main:center cross:center">
        <img v-if="iconType==0" :src="selectIcon&&(selected||status=='over')?selectIcon:iconUrl" class="icon" :style="{'width':iconWidth,'height':iconHeight,'pointEvents':'none'}">
        <div v-if="iconType==1" class="icon" :class="iconClass" :style="{fontSize:iconHeight}"></div>
      </div>
      <span ref="text" :class="{'keepOpen-span':keepOpen==true,'group-open-span':groupOpen==true&&!selected&&group!=null&&keepOpen!=true,'click-span':status=='click'}" :style="{display:status=='over'&&overDisplay?'block':'none',pointEvents: 'none'}">{{text}}</span>
      <div v-if="isArrow" class="icon" :class="{'icon-right':!selected,'icon-left':selected}" style="color:white !important;margin-right: .3vh;"></div>
    </div>
  </div>
</template>

<script>
  const TipButtonGroup = {};
  import Vue from 'vue';
  export default {
    name: "TipButton",
    data(){
      return{
        selected:false,
        outerWidth:0,
        status:null,
        groupOpen:false,
        GLOBAL_VARS
      }
    },
    props: {
      iconUrl: {
        default: '',
        type: String,
      },
      type:{
        default:0,
        type:Number,
      },
      iconWidth:{
        default:'auto',
        type:String,
      },
      isClose:{
        default:false,
        type:Boolean
      },
      iconHeight:{
        default:'46',
        type:String,
      },
      radius:{
        default:'57px',
        type:String
      },
      text: {
        default: '',
        type: String
      },
      group:{
        default:null,
        type:String
      },
      keepOpen:{
        default:false,
        type:Boolean
      },
      keepOpenWidth:{
        default:'auto',
        type:String
      },
      did:{
        default:-1,
        type:Number
      },
      isSelectShadow:{
        default:false,
        type:Boolean
      },
      overDisplay:{
        default:false,
        type:Boolean
      },
      selectIcon:{
        default: null,
        type: String,
      },
      selectColor:{
        default:null,
        type:String
      },
      iconType:{
        default:0,
        type:Number
      },
      iconClass:{
        default:'',
        type:String,
      },
      isArrow:{
        default:false,
        type:Boolean
      }
    },
    methods:{
      onClick(){
        if(this.group){
          this.status = 'click';
        }
        this.selected = !this.selected;
        if(GLOBAL_VARS.terminal=='chebaba' && this.did==1){
            Vue.prototype.loadConfigure(()=>{
              const cbbCarSeriesId=getConfigure('carVersion').cbbCarSeriesId;
              window.open(GLOBAL_VARS.chebabaCar+'/'+cbbCarSeriesId+'/compare.html','_blank');
              this.selected = false;
          })
          }else if(GLOBAL_VARS.terminal=='chebaba'&& this.did==2){
            Vue.prototype.loadConfigure(()=>{
              const cbbCarTypeId=Vue.prototype.cbbCarTypeId || getConfigure('carVersion').items[0].cbbCarTypeId;
              const cbbCarSeriesId=getConfigure('carVersion').cbbCarSeriesId;
              window.open(GLOBAL_VARS.chebabaClueCommon+'?car_series_id='+cbbCarSeriesId+'&car_type_id='+cbbCarTypeId+'&clue_type=2'+'&oss_upload_domain='+encodeURIComponent(location.href),'_blank');
              this.selected = false;
            })

        }else{
            this.$emit('select',this.did,this);
        }
        // this.$emit('select',this.did,this);
        if(this.group!=null){

          TipButtonGroup[this.group].filter(item=>{
            item.groupOpen = false;
            if(item!=this){
              item.select(false);
            }
          })
        }
      },
      onMouseOver(){
        var ua = navigator.userAgent;
        var isTablet = /(?:iPad|PlayBook)/.test(ua);
        if(isTablet){
          return;
        }
        this.status = 'over';
        var b = false;
        if (TipButtonGroup[this.group]) {
          TipButtonGroup[this.group].filter((item) => {
            if (item.isSelected() == true&&item!=this) {
              b = true;
              item.groupOpen = true;
            }
          })
        }
        this.groupOpen = b;
        this.$emit('over',this.selected);
      },
      onMouseOut(){
        this.status = 'out';
        if (TipButtonGroup[this.group]) {
          TipButtonGroup[this.group].filter((item) => {
            item.groupOpen = false;
          });
        }
        this.$emit('out',this.selected);
      },
      onResize(){
        if(this.keepOpen==true){
          if(this.keepOpenWidth!='auto'){
            this.outerWidth = this.keepOpenWidth;
          }
          else{
            this.outerWidth = $(this.$refs['button']).width();
          }

        }
        else{
          var u = window.navigator.userAgent.toLocaleLowerCase();
          var ie11 = /(trident)\/([\d.]+)/;
          var b = u.match(ie11);
          if(b){
            this.outerWidth = 'auto';
          }
          else{
            this.outerWidth = $(this.$refs['button']).width();
          }
        }
        window.requestAnimationFrame(this.onResize)
      },
      select(b){
        this.selected = b;
        this.onMouseOut();
      },
      isSelected(){
        return this.selected;
      },
      unSelectGroup(){
        if (TipButtonGroup[this.group]) {
          TipButtonGroup[this.group].filter((item) => {
            item.groupOpen = false;
            item.selected = false;
          });
        }
      }
    },
    destroyed() {
      if(this.group){
        TipButtonGroup[this.group].splice(TipButtonGroup[this.group].indexOf(this),1);
      }
    },
    mounted(){
      this.outerWidth = $(this.$refs['button']).outerWidth(true);
      this.onResize();
      this.onMouseOut();
      $(this.$refs['tipButton']).css('borderRadius','4px');
      if(this.group!=null){
        if(!TipButtonGroup[this.group]){
          TipButtonGroup[this.group] = [];
        }
        TipButtonGroup[this.group].push(this);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../css/commom.scss";
  .tip-glassbutton{
    border:solid 2px black !important;
    background-color: rgba(255,255,255,0.5);
    .keepOpen-span{
      color:black;
    }
  }
  .tip-button {
    pointer-events: all;
    transition: width .5s ease,background-color .5s ease;
    background-color: $normal-color;
    border: solid 2px $select-color;
    border-radius:4px;
    display: flex;
    align-items: center;
    overflow: hidden;
    user-select: none;
    cursor:pointer;
    span {
      font-size:0.34rem;
      white-space: nowrap;
      overflow: hidden;
      color: white;
      position: absolute;
      visibility: hidden;
      display: none;
      margin-left: $tip-margin-left;
      margin-right:$tip-margin-right;
    }
    .keepOpen-span{
      position:static;
      visibility: visible;
      display: block !important;
    }
    .click-span{
      position:static;
      visibility: visible;
    }
    .out-span{
      display: none;
    }
  }
  .group-open-select{
    span{
      position:absolute !important;
      visibility: hidden !important;
    }
  }
  .tip-button-over{
    background-color: $over-color !important;
    border-color:$select-color !important;
    span{
      position:static;
      visibility: visible;
      color:white !important;
    }
    .icon{
      color:white !important;
    }
    .group-open-span{
      position: absolute;
      visibility: hidden;
      display: block !important;
    }
  }
  .tip-button-active {
    border-color:$select-color !important;
    background-color: $select-color !important;
    span,.group-open-span{
      position:static;
      visibility: visible;
      display: block !important;
      color:white !important;
    }
    .icon{
      color:white !important;
    }
  }
  .close-tip-button-active{
    background-color: $select-color !important;
  }
  .select_shadow{
    box-shadow: 1px 1px 2px rgba(0,0,0,0.55),-1px -1px 2px rgba(0,0,0,0.55);
  }
</style>
